import { useRef, useState } from 'react';

import { t } from 'i18next';

import { useForm } from 'react-hook-form';
import { useUserContext } from '../../../contexts/user';
import { useKeycloakContext } from '../../../contexts/keycloak/context';
import { useAppContext } from '../../../contexts/app';
import { isDemo } from '../../../config/apiUrls';

const DEMO_EMAIL = 'demo@datanomik.com';

const useLogIn = () => {
  const swiperRef = useRef();

  const { loginKeycloak } = useKeycloakContext();

  const { handleAlert } = useAppContext();
  const { handleLogin, handlePreLogin } = useUserContext();

  const defaultUsername = isDemo() ? DEMO_EMAIL : '';

  const formMethodsDatanomik = useForm({
    defaultValues: {
      username: defaultUsername,
      password: '',
    },
  });

  const formMethodsOpenId = useForm({
    defaultValues: {
      username: defaultUsername,
    },
  });

  const hasFormErrors = (
    Object.entries(formMethodsDatanomik.formState.errors).length > 0
    || Object.entries(formMethodsOpenId.formState.errors).length > 0
  );

  if (hasFormErrors) {
    setTimeout(() => swiperRef.current?.updateAutoHeight(500), 50);
  }

  const [openForgotPassword, setOpenForgotPassword] = useState(false);

  const handleOnSubmitDatanomik = async ({ username, password }) => {
    handleLogin({ username, password });
  };

  const handleOnSubmitOpenId = async ({ loginDomain }) => {
    const { external } = await handlePreLogin({ loginDomain });

    if (external) {
      loginKeycloak();
    } else {
      handleAlert(t('You have no an external account enabled'), 'error');
    }
  };

  const handleOpenForgotPassword = () => setOpenForgotPassword(true);
  const handleCloseForgotPassword = () => setOpenForgotPassword(false);

  return {
    swiperRef,
    formMethodsOpenId,
    openForgotPassword,
    formMethodsDatanomik,
    handleOnSubmitOpenId,
    handleOnSubmitDatanomik,
    handleOpenForgotPassword,
    handleCloseForgotPassword,
  };
};

export default useLogIn;
